import config from '@/utils/drawCanvas/liuHeConfig'
export default ({ app }, inject) => {
  inject('env', config)
}
